module.exports = __webpack_public_path__ + "Icono_Agenda_512px.png";